import { avatarAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
	avatarAnatomy.keys,
);

const beVariant = definePartsStyle({
	container: {
		borderRadius: '50%',
		background: '#C5745B',
		color: 'white',
		lineHeight: 'unset',
		height: '41px',
		width: '41px',
	},
	excessLabel: {
		borderRadius: '50%',
		background: 'grey.800',
		border: '2px solid white',
	},
});

export const beAvatarTheme = defineMultiStyleConfig({ variants: { beVariant } });
